import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionButton } from 'core/components';
import { ActionButtonType } from 'core/enums';
import { useAgGridTableContext, useNotificationContext } from 'core/states';
import { QuoteEntityType } from 'quotes/enums';
import { Color, Variant } from 'theme/enums';

import { DuplicateQuote } from './DuplicateQuote';

interface IProps {
  entityType: QuoteEntityType;
}

export const DuplicateQuoteButton = ({ entityType = QuoteEntityType.QUOTE }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { isLoadingTopNotificationDisplayed } = useNotificationContext();
  const { selectedRows } = useAgGridTableContext();

  const isDisabled = useMemo(
    () => isLoadingTopNotificationDisplayed || selectedRows.length !== 1,
    [isLoadingTopNotificationDisplayed, selectedRows]
  );

  return (
    <>
      <ActionButton
        action={{
          label: t('buttonLabelDuplicateQuote', { entityType }),
          type: ActionButtonType.BUTTON,
          color: Color.SUCCESS,
          variant: isDisabled ? Variant.OUTLINED : Variant.SOLID,
          onClick: () => setIsOpen(true),
          disabled: isDisabled,
        }}
      />

      <DuplicateQuote isOpen={isOpen} onClose={() => setIsOpen(false)} entityType={entityType} />
    </>
  );
};
